import React from 'react'
import './coming-soon.css'
export default function ComingSoon() {
    return (
        <div className='soon'>
            <div className="overlay">

            </div>
            <div className="spinner-wrapper">
                <div className="spinner">

                </div>
                <p>Coming soon...</p>
            </div>
        </div>
    )
}
